module.exports = __webpack_public_path__ + "img/filingFee_active.7df463db.svg";